import { createClient } from "@supabase/supabase-js";

// Supabase 설정
const supabaseUrl = "https://loypzzybedodjwqyyrgi.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxveXB6enliZWRvZGp3cXl5cmdpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDg4MjUwMjMsImV4cCI6MjA2NDQwMTAyM30.vfnh-kArdzjjxvOyKhCaQf2wSt3XH37lo4A1Ex4DttU";

export const supabase = createClient(supabaseUrl, supabaseKey);

// 축하한마디 타입 정의
export interface GuestbookEntry {
  id?: string;
  name: string;
  message: string;
  side: "groom" | "bride" | "none";
  created_at?: string;
}

// 축하한마디 목록 가져오기
export const getGuestbookEntries = async (): Promise<GuestbookEntry[]> => {
  try {
    const { data, error } = await supabase
      .from("guestbook")
      .select("*")
      .order("created_at", { ascending: false });

    if (error) {
      console.error("Error fetching guestbook entries:", error);
      throw error;
    }

    return data || [];
  } catch (error) {
    console.error("Error in getGuestbookEntries:", error);
    return [];
  }
};

// 축하한마디 추가
export const addGuestbookEntry = async (
  entry: Omit<GuestbookEntry, "id" | "created_at">
): Promise<GuestbookEntry> => {
  try {
    const { data, error } = await supabase
      .from("guestbook")
      .insert([
        {
          name: entry.name,
          message: entry.message,
          side: entry.side,
          created_at: new Date().toISOString(),
        },
      ])
      .select()
      .single();

    if (error) {
      console.error("Error adding guestbook entry:", error);
      throw error;
    }

    return data;
  } catch (error) {
    console.error("Error in addGuestbookEntry:", error);
    throw error;
  }
};

// 축하한마디 삭제
export const deleteGuestbookEntry = async (id: string): Promise<void> => {
  try {
    const { error } = await supabase.from("guestbook").delete().eq("id", id);

    if (error) {
      console.error("Error deleting guestbook entry:", error);
      throw error;
    }
  } catch (error) {
    console.error("Error in deleteGuestbookEntry:", error);
    throw error;
  }
};

// 실시간 구독 (선택사항)
export const subscribeToGuestbook = (
  callback: (entries: GuestbookEntry[]) => void
) => {
  const subscription = supabase
    .channel("guestbook-changes")
    .on(
      "postgres_changes",
      {
        event: "*",
        schema: "public",
        table: "guestbook",
      },
      async () => {
        // 변경사항이 있을 때 전체 목록 다시 가져오기
        const entries = await getGuestbookEntries();
        callback(entries);
      }
    )
    .subscribe();

  return () => {
    subscription.unsubscribe();
  };
};
